import React from 'react';
import bg from '../../images/about/about-bg.png';
import logo from '../../images/about/ILFK-logo-2.png';
import art from '../../images/about/about-section-graphics.jpg';
import rajan from '../../images/about/dr-rajan-n-khobragade.jpg';
import arjun from '../../images/about/mr-arjun-pandian-IAS.jpg';
import ashokan from '../../images/about/mr.ashokan-charuvil.jpg';
import pinarai from '../../images/about/pinarayi-vijayan.jpg';
import aboobak from '../../images/about/prof-cp-aboobacker.jpg';
import sachidhan from '../../images/about/prof-k-sachidananthan.jpg';
import saji from '../../images/about/saji-cheriyan.jpg';
import divya from '../../images/about/Dr._Divya_S._Iyer_IAS.jpg';


const About = () => {
  const speakers = [
    { name: "Mr Pinarayi Vijayan", title: "Chief Minister", image: pinarai },
    { name: "Mr Saji Cherian", title: "Minister for Culture", image: saji },
    { name: "Dr Rajan N Khobragade", title: "Additional Chief Secretary, Cultural Affairs Department", image: rajan },
    { name: "Dr Divya S. Iyer", title: "Director, Kerala Culture", image: divya },
    { name: "Prof. K. Satchidanandan", title: "President", image: sachidhan },
    { name: "Mr Ashokan Charuvil", title: "Vice-president", image: ashokan },
    { name: "Prof. C.P. Aboobacker", title: "Secretary", image: aboobak },
    { name: "Mr Arjun Pandian, IAS", title: "Treasurer, Thrissur district collector", image: arjun },
  ];

  return (
    <div className="relative overflow-hidden aboutus">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${bg})` }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto py-12">
        {/* Title */}
        <div className="text-center mb-10">
          <h1 className="text-2xl font-bold text-black">കേരള സാർവദേശീയ സാഹിത്യോത്സവം</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start aboutContent">
          {/* Left Side */}
          {/* <div className="flex flex-col items-center lg:items-start px-2 w-150 aboutLeft">
            <div className="relative w-150 h-90">
              <img src={art} alt="Art" className="w-full h-full object-cover rounded-lg shadow-2xl" />
              <div className="absolute bottom-4 left-4">
                <img src={logo} alt="ILFK Logo" className="w-16 h-16 object-contain" />
              </div>
            </div>
            <div className="mt-4 text-xs text-black leading-relaxed mr-60 md:mr-0 malPara">
              <p className='text-[15px] leading-5 '>
                കേരള സാഹിത്യ അക്കാദമിയുടെയും കേരള സർക്കാർ സാംസ്കാരികവകുപ്പിന്റെയും ആഭിമുഖ്യത്തിൽ
                സംഘടിപ്പിക്കുന്ന സാർവദേശീയ സാഹിത്യോത്സവം അതിന്റെ രണ്ടാം പതിപ്പിലേക്കു
                കടക്കുകയാണ്. പൂർണമായ അർത്ഥത്തിൽ ജനങ്ങളുടെ സാഹിത്യോത്സവമാണിത്.
                എഴുത്തുകാരും ചിന്തകരും വായനക്കാരും ഒന്നിക്കുന്ന ഈ ഉത്സവം അവതരണങ്ങളും
                ചർച്ചകളും ശില്പശാലകളും പ്രഭാഷണങ്ങളും കൊണ്ടു സമ്പന്നമാകുന്നു.
                ജനാധിപത്യത്തിനും സാംസ്കാരികസംവാദങ്ങൾക്കും വേദിയൊരുക്കുന്ന ഈ
                സാഹിത്യോത്സവത്തിന്റെ പുതിയ പതിപ്പിലേക്കു സ്വാഗതം.
              </p>
            </div>
          </div> */}

          <div className="flex flex-col items-start md:items-center lg:items-start px-4 sm:px-6 lg:px-2 w-full max-w-[768px] mx-auto aboutLeft">
            {/* Image Block */}
            {/* <div className="relative w-full max-w-[768px] h-auto"> */}
            <div className="relative w-full max-w-[768px] sm:h-auto md:h-auto lg:max-h-[450px]">
              <img
                src={art}
                alt="Art"
                className="w-full sm:h-auto md:h-auto lg:max-h-[450px] object-cover rounded-lg shadow-2xl"
              />
              <div className="absolute bottom-4 left-4">
                <img src={logo} alt="ILFK Logo" className="w-16 h-16 object-contain" />
              </div>
            </div>

            {/* Text Block */}
            <div className="mt-4 text-xs text-black leading-relaxed px-2 sm:px-4 md:px-6 lg:px-0 w-full">
              <p className="text-[15px] leading-5">
                കേരള സാഹിത്യ അക്കാദമിയുടെയും കേരള സർക്കാർ സാംസ്കാരികവകുപ്പിന്റെയും
                ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിക്കുന്ന സാർവദേശീയ സാഹിത്യോത്സവം അതിന്റെ
                രണ്ടാം പതിപ്പിലേക്കു കടക്കുകയാണ്. പൂർണമായ അർത്ഥത്തിൽ ജനങ്ങളുടെ
                സാഹിത്യോത്സവമാണിത്. എഴുത്തുകാരും ചിന്തകരും വായനക്കാരും ഒന്നിക്കുന്ന
                ഈ ഉത്സവം അവതരണങ്ങളും ചർച്ചകളും ശില്പശാലകളും പ്രഭാഷണങ്ങളും കൊണ്ടു
                സമ്പന്നമാകുന്നു. ജനാധിപത്യത്തിനും സാംസ്കാരികസംവാദങ്ങൾക്കും
                വേദിയൊരുക്കുന്ന ഈ സാഹിത്യോത്സവത്തിന്റെ പുതിയ പതിപ്പിലേക്കു സ്വാഗതം.
              </p>
            </div>
          </div>


          {/* Right Side Speaker Grid Layout (as per your request) */}
          <div className="px-1 aboutRight">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl">
              {/* First 6 cards - 2 rows of 3 */}
              {speakers.slice(0, 8).map((speaker, index) => (
                <div
                  key={index}
                  className="rounded-lg shadow-md hover:shadow-xl transform hover:scale-105 transition duration-300 p-4 text-center min-h-[160px] bg-white/60 aboutImg"
                >
                  <div className="w-[100px] h-[100px] mx-auto mb-2 overflow-hidden bg-gray-200">
                    <img src={speaker.image} alt={speaker.name} className="w-full h-full object-contain" />
                  </div>
                  <h3 className="font-semibold text-sm text-black">{speaker.name}</h3>
                  <p className="text-xs text-gray-700">{speaker.title}</p>
                </div>
              ))}

              {/* Last row - small column (Arjun), large column (About Text) */}
              {/* <div className=" rounded-lg shadow-md p-4 lg:mt-3 text-center h-55 md:min-h-[190px] bg-white/60 transform hover:scale-105 transition duration-300 aboutLastImg">
                <div className="w-[100px] h-[100px] mx-auto mb-2 overflow-hidden bg-gray-200">
                  <img src={arjun} alt="Arjun" className="w-full h-full object-cover" />
                </div>
                <h3 className="font-semibold text-sm text-black">{speakers[6].name}</h3>
                <p className="text-xs text-gray-700">{speakers[6].title}</p>
              </div> */}

              {/* <div className="col-span-2 rounded-lg p-1 text-sm leading-relaxed text-black w-full engPara">
                <p className='text-[15px]  leading-5'>
                  The International Literature Festival of Kerala (ILFK), now in its second
                  edition, is organized by Kerala Sahitya Akademi and the Department of
                  Culture, Government of Kerala. It is a true people's festival that
                  celebrates the power of literature to connect, question, and inspire.
                  Set in the culturally vibrant landscape of Kerala, ILFK brings together
                  writers, artists, thinkers, and readers from across the globe for a rich
                  tapestry of conversations, performances, readings, and workshops. With a
                  strong commitment to inclusivity and cultural dialogue, the festival
                  offers a dynamic space where diverse voices meet and literature becomes a
                  shared, living experience for all.
                </p>
              </div> */}
            </div>
          </div>
        </div>
        <div className="rounded-lg lg:px-2 md:px-10 lg:p-0 p-5 lg:pt-5 text-sm leading-relaxed text-black w-full engPara">
          <p className='text-[15px]  leading-5'>
            The International Literature Festival of Kerala (ILFK), now in its second
            edition, is organized by Kerala Sahitya Akademi and the Department of
            Culture, Government of Kerala. It is a true people's festival that
            celebrates the power of literature to connect, question, and inspire.
            Set in the culturally vibrant landscape of Kerala, ILFK brings together
            writers, artists, thinkers, and readers from across the globe for a rich
            tapestry of conversations, performances, readings, and workshops. With a
            strong commitment to inclusivity and cultural dialogue, the festival
            offers a dynamic space where diverse voices meet and literature becomes a
            shared, living experience for all.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;




// import React from 'react';
// import bg from '../../images/about/about-bg.png';
// import logo from '../../images/about/ILFK-logo-2.png';
// import art from '../../images/about/about-section-graphics.jpg';
// import rajan from '../../images/about/dr-rajan-n-khobragade.jpg';
// import arjun from '../../images/about/mr-arjun-pandian-IAS.jpg';
// import ashokan from '../../images/about/mr.ashokan-charuvil.jpg';
// import pinarai from '../../images/about/pinarayi-vijayan.jpg';
// import aboobak from '../../images/about/prof-cp-aboobacker.jpg';
// import sachidhan from '../../images/about/prof-k-sachidananthan.jpg';
// import saji from '../../images/about/saji-cheriyan.jpg';

// const About = () => {
//   const speakers = [
//     { name: "Mr Pinarayi Vijayan", title: "Chief Minister", image: pinarai },
//     { name: "Mr Saji Cherian", title: "Minister for Culture", image: saji },
//     { name: "Dr Rajan N Khobragade", title: "Additional Chief Secretary, Cultural Affairs Department", image: rajan },
//     { name: "Prof. K. Satchidanandan", title: "President", image: sachidhan },
//     { name: "Mr Ashokan Charuvil", title: "Vice-president", image: ashokan },
//     { name: "Prof. C.P. Aboobacker", title: "Secretary", image: aboobak },
//     { name: "Mr Arjun Pandian, IAS", title: "Treasurer, Thrissur district collector", image: arjun },
//   ];

//   return (
//     <div className="relative overflow-hidden aboutus">
//       {/* Background */}
//       <div className="absolute inset-0">
//         <div className="w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${bg})` }}></div>
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto py-12">
//         {/* Title */}
//         <div className="text-center mb-10">
//           <h1 className="text-2xl font-bold text-black">കേരള സാർവദേശീയ സാഹിത്യോത്സവം</h1>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start aboutContent">
//           {/* Left Side */}
//           {/* <div className="flex flex-col items-center lg:items-start px-2 w-150 aboutLeft">
//             <div className="relative w-150 h-90">
//               <img src={art} alt="Art" className="w-full h-full object-cover rounded-lg shadow-2xl" />
//               <div className="absolute bottom-4 left-4">
//                 <img src={logo} alt="ILFK Logo" className="w-16 h-16 object-contain" />
//               </div>
//             </div>
//             <div className="mt-4 text-xs text-black leading-relaxed mr-60 md:mr-0 malPara">
//               <p className='text-[15px] leading-5 '>
//                 കേരള സാഹിത്യ അക്കാദമിയുടെയും കേരള സർക്കാർ സാംസ്കാരികവകുപ്പിന്റെയും ആഭിമുഖ്യത്തിൽ
//                 സംഘടിപ്പിക്കുന്ന സാർവദേശീയ സാഹിത്യോത്സവം അതിന്റെ രണ്ടാം പതിപ്പിലേക്കു
//                 കടക്കുകയാണ്. പൂർണമായ അർത്ഥത്തിൽ ജനങ്ങളുടെ സാഹിത്യോത്സവമാണിത്.
//                 എഴുത്തുകാരും ചിന്തകരും വായനക്കാരും ഒന്നിക്കുന്ന ഈ ഉത്സവം അവതരണങ്ങളും
//                 ചർച്ചകളും ശില്പശാലകളും പ്രഭാഷണങ്ങളും കൊണ്ടു സമ്പന്നമാകുന്നു.
//                 ജനാധിപത്യത്തിനും സാംസ്കാരികസംവാദങ്ങൾക്കും വേദിയൊരുക്കുന്ന ഈ
//                 സാഹിത്യോത്സവത്തിന്റെ പുതിയ പതിപ്പിലേക്കു സ്വാഗതം.
//               </p>
//             </div>
//           </div> */}

//           <div className="flex flex-col items-start md:items-center lg:items-start px-4 sm:px-6 lg:px-2 w-full max-w-[768px] mx-auto aboutLeft">
//             {/* Image Block */}
//             <div className="relative w-full max-w-[768px] h-auto">
//               <img
//                 src={art}
//                 alt="Art"
//                 className="w-full h-auto object-cover rounded-lg shadow-2xl"
//               />
//               <div className="absolute bottom-4 left-4">
//                 <img src={logo} alt="ILFK Logo" className="w-16 h-16 object-contain" />
//               </div>
//             </div>

//             {/* Text Block */}
//             <div className="mt-4 text-xs text-black leading-relaxed px-2 sm:px-4 md:px-6 lg:px-0 w-full">
//               <p className="text-[15px] leading-5">
//                 കേരള സാഹിത്യ അക്കാദമിയുടെയും കേരള സർക്കാർ സാംസ്കാരികവകുപ്പിന്റെയും
//                 ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിക്കുന്ന സാർവദേശീയ സാഹിത്യോത്സവം അതിന്റെ
//                 രണ്ടാം പതിപ്പിലേക്കു കടക്കുകയാണ്. പൂർണമായ അർത്ഥത്തിൽ ജനങ്ങളുടെ
//                 സാഹിത്യോത്സവമാണിത്. എഴുത്തുകാരും ചിന്തകരും വായനക്കാരും ഒന്നിക്കുന്ന
//                 ഈ ഉത്സവം അവതരണങ്ങളും ചർച്ചകളും ശില്പശാലകളും പ്രഭാഷണങ്ങളും കൊണ്ടു
//                 സമ്പന്നമാകുന്നു. ജനാധിപത്യത്തിനും സാംസ്കാരികസംവാദങ്ങൾക്കും
//                 വേദിയൊരുക്കുന്ന ഈ സാഹിത്യോത്സവത്തിന്റെ പുതിയ പതിപ്പിലേക്കു സ്വാഗതം.
//               </p>
//             </div>
//           </div>


//           {/* Right Side Speaker Grid Layout (as per your request) */}
//           <div className="px-1 aboutRight">
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl">
//               {/* First 6 cards - 2 rows of 3 */}
//               {speakers.slice(0, 6).map((speaker, index) => (
//                 <div
//                   key={index}
//                   className="rounded-lg shadow-md hover:shadow-xl transform hover:scale-105 transition duration-300 p-4 text-center min-h-[160px] bg-white/60 aboutImg"
//                 >
//                   <div className="w-[100px] h-[100px] mx-auto mb-2 overflow-hidden bg-gray-200">
//                     <img src={speaker.image} alt={speaker.name} className="w-full h-full object-contain" />
//                   </div>
//                   <h3 className="font-semibold text-sm text-black">{speaker.name}</h3>
//                   <p className="text-xs text-gray-700">{speaker.title}</p>
//                 </div>
//               ))}

//               {/* Last row - small column (Arjun), large column (About Text) */}
//               <div className=" rounded-lg shadow-md p-4 lg:mt-3 text-center h-55 md:min-h-[190px] bg-white/60 transform hover:scale-105 transition duration-300 aboutLastImg">
//                 <div className="w-[100px] h-[100px] mx-auto mb-2 overflow-hidden bg-gray-200">
//                   <img src={arjun} alt="Arjun" className="w-full h-full object-cover" />
//                 </div>
//                 <h3 className="font-semibold text-sm text-black">{speakers[6].name}</h3>
//                 <p className="text-xs text-gray-700">{speakers[6].title}</p>
//               </div>

//               <div className="col-span-2 rounded-lg p-1 text-sm leading-relaxed text-black w-full engPara">
//                 <p className='text-[15px]  leading-5'>
//                   The International Literature Festival of Kerala (ILFK), now in its second
//                   edition, is organized by Kerala Sahitya Akademi and the Department of
//                   Culture, Government of Kerala. It is a true people's festival that
//                   celebrates the power of literature to connect, question, and inspire.
//                   Set in the culturally vibrant landscape of Kerala, ILFK brings together
//                   writers, artists, thinkers, and readers from across the globe for a rich
//                   tapestry of conversations, performances, readings, and workshops. With a
//                   strong commitment to inclusivity and cultural dialogue, the festival
//                   offers a dynamic space where diverse voices meet and literature becomes a
//                   shared, living experience for all.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default About;
